import { Component, HostBinding, HostListener, Input, OnInit } from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, ValidationErrors, Validator } from '@angular/forms';

@Component({
  selector: 'app-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: SelectComponent,
      multi: true,
    },
  ],
  standalone: false,
})
export class SelectComponent implements ControlValueAccessor, Validator, OnInit {
  @Input() options: any[] | null = [];
  @Input() displayIconFn: (item: any) => any = (x) => x.icon;
  @Input() displayFn: (item: any) => any = (x) => x.label;
  @Input() extraDisplayFn: (item: any) => any = () => null;
  @Input() valueFn: (item: any) => any = (x) => x.value;
  @Input() label?: string;
  @Input() placeholder?: string;
  @Input() disabled = false;

  @HostBinding('class.hide-background')
  @Input()
  hideBackground = false;

  @Input() mode: 'select' | 'radio' | 'checklist' = 'select';
  innerControl = new FormControl();

  ngOnInit() {
    this.innerControl.valueChanges.subscribe((x) => {
      if (this.propagateOnChange) {
        this.propagateOnChange(x);
      }
    });
  }

  /** ControlValueAccessor Implementation */

  writeValue(obj: any): void {
    this.innerControl.setValue(obj, { emitEvent: false, onlySelf: true });
  }

  propagateOnChange?: (_: any) => void;
  registerOnChange(fn: (_: any) => void): void {
    this.propagateOnChange = fn;
  }

  @HostListener('click')
  propagateOnTouched?: () => void;
  registerOnTouched(fn: () => void): void {
    this.propagateOnTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    isDisabled ? this.innerControl.disable() : this.innerControl.enable();
  }

  onClick(ev: MouseEvent, opt: any) {
    ev.preventDefault();
    ev.cancelBubble = true;
    this.innerControl.setValue(this.valueFn ? this.valueFn(opt) : opt);
  }

  validate(_control: AbstractControl): ValidationErrors | null {
    return this.innerControl.errors;
  }
}
